import Form from "react-bootstrap/Form";
import { Modal } from "react-bootstrap";
import React, { useContext, useEffect, useState } from "react";
import constants from "../../../constants";
import Offcanvas from "react-bootstrap/Offcanvas";
import AlertContext from "../../../context/AlertContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useCommonFunctionHooks from "../../../Hooks/useCommonFunctionHooks";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";
import MobileViewSetUpHooks from "../../../Hooks/InstructionPage/MobileViewSetUpHooks";
// import useUploadLargeFileToS3 from "../../../Hooks/useUploadLargeFileToS3";
import useS3FileManagement from "../../../Hooks/useS3FileManagement";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import TabSwitching from "./TabSwitching";

const ProctoredPopup = ({ showProctoring, setShowProctoring }) => {
  const Alert = useContext(AlertContext);
  const axios = useAxiosPrivate();
  const { folderName } = MobileViewSetUpHooks();
  // const { deleteS3Objects } = useUploadLargeFileToS3();
  const { getPreSignedUrl, deleteS3Objects } = useS3FileManagement();

  const { getHeaderDetailsForAxios, getCatchBlockDetails } =
    useCommonFunctionHooks();
  const [profileData, setProfileData] = useState({});
  const [showProfile, setShowProfile] = useState(false);
  const [deleteImages, setDeleteImages] = useState({
    withKey: [],
    withOutKey: [],
  });

  const [deleteDPImages, setDeleteDPImages] = useState({
    withKey: [],
    withOutKey: [],
  });

  const [activeTab, setActiveTab] = useState("activity");
  const [showAll, setShowAll] = useState(false);
  const mapUrl = `https://www.google.com/maps?q=${profileData?.location?.latitude},${profileData?.location?.longitude}`;
  useEffect(() => {
    const handleShowProctoring = () => {
      let payLoad = {
        lpid: Alert.showBreadCrumbsData.lpId,
        libtypeid: Alert.showBreadCrumbsData.type,
        userid: Alert.showBreadCrumbsData.learnerId,
      };

      if (
        Alert.showBreadCrumbsData.type === constants.libTypeIds.CODING_CHALLENGE
      ) {
        payLoad.testid = Alert.showBreadCrumbsData.testId;
        payLoad.qnid = Alert.showBreadCrumbsData.questionId;
        payLoad.qnno = Alert.showBreadCrumbsData.questionNo;
        payLoad.testconfigid = Alert.showBreadCrumbsData.testConfigId;
      } else if (
        Alert.showBreadCrumbsData.type === constants.libTypeIds.ASSIGNMENT
      ) {
        payLoad.libid = Alert.showBreadCrumbsData.testId;
      } else {
        payLoad.qnid = Alert.showBreadCrumbsData.testId;
      }

      Alert.setIsLoaded(true);
      axios
        .post("node/admin/userproctoring", payLoad, getHeaderDetailsForAxios())
        .then(async (res) => {
          if (res.data === "") {
            Alert.setShowNotify({
              show: true,
              title: "Info",
              msg: "No data available",
            });
          } else {
            let data = res.data;
            console.log("data from api:", data);

            let urlData = await getPreSignedUrl(
              `Proctoring/Registration/${Alert.learnerId}/${Alert.learnerId}.png`,
              undefined,
              "png",
              "GET"
            );
            data.registerUrl = urlData.url;

            if (data.hasOwnProperty("proctoringdatas")) {
              // Collect all S3 file paths
              let filesToFetch = [];
              data.proctoringdatas.forEach((item, i) => {
                let filePath = `Proctoring/${Alert.showBreadCrumbsData.testId}/`;
                if (
                  parseInt(Alert.showBreadCrumbsData.type) ===
                  constants.libTypeIds.CODING_CHALLENGE
                ) {
                  filePath += `${Alert.showBreadCrumbsData.questionId}/${Alert.learnerId}/`;
                } else {
                  filePath += `${Alert.learnerId}/`;
                }
                filePath += item.imagename;
                console.log("filepath:", filePath);
                item.s3Key = filePath;
                filesToFetch.push(filePath);
              });
              console.log("filesToFetch:", filesToFetch);

              const proctoringUrls = await getPreSignedUrl(
                filesToFetch,
                undefined,
                "png",
                "GET"
              );
              data.proctoringdatas.forEach((item, i) => {
                console.log("proctoringUrls:", proctoringUrls);
                console.log("item:", item, "i:", proctoringUrls.url[i]);
                item.imagePresignedUrl = proctoringUrls.url[i];
              });

              // Add DP images
              if (data.dpPics && data.dpPics.length) {
                let dpPicsFilesToFetch = [];
                data.dpPics.forEach((dp, i) => {
                  let dpFilePath = `${folderName()}/proctoring/${Alert.showBreadCrumbsData.testId
                    }/`;
                  if (
                    parseInt(Alert.showBreadCrumbsData.type) ===
                    constants.libTypeIds.CODING_CHALLENGE
                  ) {
                    dpFilePath += `${Alert.showBreadCrumbsData.questionId}/${Alert.learnerId}/`;
                  } else {
                    dpFilePath += `${Alert.learnerId}/`;
                  }
                  dpFilePath += dp.imagename;
                  dp.s3Key = dpFilePath;
                  dpPicsFilesToFetch.push(dpFilePath);
                });

                console.log("dpPicsFilesToFetch:", dpPicsFilesToFetch);

                const dpPicsUrls = await getPreSignedUrl(
                  dpPicsFilesToFetch,
                  "DP",
                  "png",
                  "GET"
                );
                data.dpPics.forEach((dp, i) => {
                  if (i < data.proctoringdatas.length) {
                    const proctorItem = data.proctoringdatas[i];
                    proctorItem.dpimagename = dp.imagename || dp.fileName;
                    proctorItem.dpimagePresignedUrl = dpPicsUrls.url[i];
                    proctorItem.dpmultifaces = dp.multifaces;
                    proctorItem.dpfacedetected = dp.facedetected;
                    proctorItem.dpphonedetected = dp.phonedetected;
                    proctorItem.dpexternaldevices = dp.externaldevices;
                    proctorItem.dpcreatedTimeStamp = dp.createdTimeStamp;
                  } else {
                    // console.warn(`Index ${i} exceeds proctoringdatas array length`);
                  }
                });
              }

              // for (let i = 0; i < data.proctoringdatas.length; i++) {
              //   let filePath = `Proctoring/${Alert.showBreadCrumbsData.testId}/`;

              //   if (
              //     parseInt(Alert.showBreadCrumbsData.type) ===
              //     constants.libTypeIds.CODING_CHALLENGE
              //   )
              //     filePath += `${Alert.showBreadCrumbsData.questionId}/${Alert.learnerId}/`;
              //   else filePath += `${Alert.learnerId}/`;

              //   filePath += data.proctoringdatas[i].imagename;
              //   let fileType = data.proctoringdatas[i].imageName?.split(".").pop();

              //   let url = await getPreSignedUrl(filePath, undefined, fileType, "GET");

              //   data.proctoringdatas[i].imagePresignedUrl = url.url;
              //   // Process the DP image
              //   if (data.dpPics && data.dpPics[i]) {
              //     let dpFilePath = `${folderName()}/proctoring/${
              //       Alert.showBreadCrumbsData.testId
              //     }/`;
              //     if (
              //       parseInt(Alert.showBreadCrumbsData.type) ===
              //       constants.libTypeIds.CODING_CHALLENGE
              //     )
              //       dpFilePath += `${Alert.showBreadCrumbsData.questionId}/${Alert.learnerId}/`;
              //     else dpFilePath += `${Alert.learnerId}/`;
              //     dpFilePath += data.dpPics[i].imagename;
              //     let fileType = data.proctoringdatas[i].imageName?.split(".").pop();
              //     const dpUrl = await getPreSignedUrl(dpFilePath, "DP", fileType, "GET");
              //     // Add DP properties to the proctoring data item
              //     data.proctoringdatas[i].dpimagename =
              //       data.dpPics[i].imagename;
              //     data.proctoringdatas[i].dpimagePresignedUrl = dpUrl.url;
              //     data.proctoringdatas[i].dpmultifaces =
              //       data.dpPics[i].multifaces;
              //     data.proctoringdatas[i].dpfacedetected =
              //       data.dpPics[i].facedetected;
              //     data.proctoringdatas[i].dpphonedetected =
              //       data.dpPics[i].phonedetected;
              //     data.proctoringdatas[i].dpexternaldevices =
              //       data.dpPics[i].externaldevices;
              //     data.proctoringdatas[i].dpcreatedTimeStamp =
              //       data.dpPics[i].createdTimeStamp;
              //   }
              // }
            }

            // if (data.hasOwnProperty("dpPics")) {
            //   console.log("DP Pics in : ", data.dpPics);
            //   for (let i = 0; i < data.dpPics.length; i++) {
            //     let filePath = `dev/proctoring/${Alert.showBreadCrumbsData.testId}/${Alert.showBreadCrumbsData.questionId}/${Alert.learnerId}/${data.dpPics[i].imagename}`;

            //     let url = await getPreSignedUrl(filePath, "dp");

            //     data.dpPics[i].imagePresignedUrl = url;
            //   }
            // }

            res.data = data;
            // Alert.setProfile(res.data);
            console.log("setting state pros datAa:", res.data);

            setProfileData(res.data);
          }
        })
        .catch((err) => {
          getCatchBlockDetails(err, "proctor");
        })
        .finally(() => Alert.setIsLoaded(false));
    };
    handleShowProctoring();
  }, []);

  const handleProctoringClosePopup = () => {
    setShowProctoring(false);
    setProfileData({});
  };

  const getProctorData = () => {
    if (!showAll) {
      return profileData.proctoringdatas?.filter(
        (data) => parseInt(data.probabilityofmatch) !== 100
      );
    } else {
      return profileData.proctoringdatas;
    }
  };

  const getImageData = () => {
    const details = JSON.parse(JSON.stringify(profileData ?? "{}"));
    if (!showAll) {
      const filteredData = details?.proctoringdatas?.filter(
        (data) => parseInt(data.probabilityofmatch) !== 100
      );

      return {
        ...details,
        proctoringdatas: filteredData,
      };
    } else {
      return details;
    }
  };

  const handleSelectImage = (checked, imageName, dpimagename) => {
    let details = getImageData();
    // console.log("Details: ", details);
    // let dpDetails = getDPImageData();

    let imageNames = JSON.parse(JSON.stringify(deleteImages));

    let dpImageNames = JSON.parse(JSON.stringify(deleteDPImages));

    if (checked) {
      if (imageName === "all") {
        imageNames.withKey = [];
        imageNames.withOutKey = [];
        dpImageNames.withKey = [];
        dpImageNames.withOutKey = [];

        details.proctoringdatas = details.proctoringdatas.map((detail) => {
          detail.isChecked = true;

          // Proctoring image
          const fullPath = new URL(detail.imagePresignedUrl).pathname.slice(1);
          const pathWithoutFile = fullPath.substring(
            0,
            fullPath.lastIndexOf("/") + 1
          );
          imageNames.withKey.push({
            Key: `${pathWithoutFile}${detail.imagename}`,
          });
          imageNames.withOutKey.push(detail.imagename);

          // DP image (if exists)
          if (detail.dpimagePresignedUrl && detail.dpimagename) {
            const dpFullPath = new URL(
              detail.dpimagePresignedUrl
            ).pathname.slice(1);
            const dpPathWithoutFile = dpFullPath.substring(
              0,
              dpFullPath.lastIndexOf("/") + 1
            );
            dpImageNames.withKey.push({
              Key: `${dpPathWithoutFile}${detail.dpimagename}`,
            });
            dpImageNames.withOutKey.push(detail.dpimagename);
          }

          return detail;
        });
        // Alert.setProfile(details);
      } else {
        details.proctoringdatas = details.proctoringdatas.map((detail) => {
          if (detail.imagename === imageName) {
            detail.isChecked = true;
            const fullPath = new URL(detail.imagePresignedUrl).pathname.slice(
              1
            );
            const pathWithoutFile = fullPath.substring(
              0,
              fullPath.lastIndexOf("/") + 1
            );
            imageNames.withKey.push({ Key: `${pathWithoutFile}${imageName}` });
            imageNames.withOutKey.push(imageName);
            if (dpimagename) {
              const dpFullPath = new URL(
                detail.dpimagePresignedUrl
              ).pathname.slice(1);
              const dpPathWithoutFile = dpFullPath.substring(
                0,
                dpFullPath.lastIndexOf("/") + 1
              );
              dpImageNames.withKey.push({
                Key: `${dpPathWithoutFile}${dpimagename}`,
              });
              dpImageNames.withOutKey.push(dpimagename);
            }
          }

          return detail;
        });
        // setDeleteImages(imageNames);
        // setDeleteDPImages(dpImageNames);
        // Alert.setProfile(details);
        // setProfileData(details);
      }
    } else {
      if (imageName === "all") {
        imageNames.withKey = [];
        imageNames.withOutKey = [];
        dpImageNames.withKey = [];
        dpImageNames.withOutKey = [];
        // Reset all images to unchecked
        details.proctoringdatas = details.proctoringdatas.map((detail) => {
          detail.isChecked = false;

          return detail;
        });
      } else {
        imageNames.withKey = imageNames.withKey.filter(
          (imgName) => !imgName.Key.includes(imageName)
        );
        imageNames.withOutKey = imageNames.withOutKey.filter(
          (imgName) => imgName !== imageName
        );
        details.proctoringdatas = details.proctoringdatas.map((detail) => {
          if (detail.imagename === imageName) detail.isChecked = false;

          return detail;
        });
        if (dpimagename) {
          dpImageNames.withKey = imageNames.withKey.filter(
            (imgName) => !imgName.Key.includes(dpimagename)
          );
          dpImageNames.withOutKey = imageNames.withOutKey.filter(
            (imgName) => imgName !== dpimagename
          );
        }
      }

      //   setProfileData(details);
      // setDeleteImages(imageNames);
      // setDeleteDPImages(dpImageNames);
    }
    setProfileData(details);
    setDeleteImages(imageNames);
    setDeleteDPImages(dpImageNames);

    // console.log("Delete Images: ", imageNames);
    // console.log("Delete DP Images: ", dpImageNames);
  };

  const handleDeleteImg = async (event) => {
    event.preventDefault();
    try {
      Alert.setIsLoaded(true);

      let res = await axios.post(
        "node/admin/userproctoring/image",
        {
          imageNames: deleteImages.withOutKey,
          dpImageNames: deleteDPImages.withOutKey,
        },
        getHeaderDetailsForAxios()
      );

      if (res.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
        let result = await deleteS3Objects(deleteImages.withKey);
        let dpResult;
        if (deleteDPImages.withKey.length > 0) {
          // console.log("Delete DP Images in deleteS3Objects: ", deleteDPImages);
          dpResult = await deleteS3Objects(deleteDPImages.withKey, "DP");
        } else {
          // console.log("No DP Images to delete");
          dpResult = "Success";
        }

        // console.log("Delete Result: ", result, "DP Result: ", dpResult);
        if (result === "Success" && dpResult === "Success") {
          Alert.setShowNotify({
            show: true,
            title: "Success",
            msg: res.data.msg,
          });

          let details = JSON.parse(JSON.stringify(profileData));

          details.proctoringdatas = details.proctoringdatas?.filter(
            (detail) => !deleteImages.withOutKey.includes(detail.imagename)
          );
          console.log("Details checking:", details);
          setProfileData(details);
          setDeleteImages({ withKey: [], withOutKey: [] });
          setDeleteDPImages({ withKey: [], withOutKey: [] });
        }
      } else if (
        res.data.resultCode === constants.RESULT_STATUS.TECHNICAL_ERROR
      ) {
        Alert.setShowNotify({
          show: true,
          title: "Error",
          msg: res.data.msg,
        });
      } else {
        Alert.setShowNotify({
          show: true,
          title: "Error",
          msg: "Something went wrong. Please try again later.",
        });
      }
    } catch (err) {
      getCatchBlockDetails(err);
    } finally {
      Alert.setIsLoaded(false);
    }
  };

  console.log("pros,,,,,,,,,,,,,,,,,", profileData);

  return (
    <Offcanvas
      placement="top"
      id="proctoringDetailContainer"
      show={showProctoring}
    >
      {/* {Alert.isLoaded && <Loading />} */}

      <div className="proctoringTitleSection">
        <FontAwesomeIcon
          icon={faXmark}
          className="proctoringCloseIcon"
          onClick={() => {
            handleProctoringClosePopup();
            setDeleteImages({
              withKey: [],
              withOutKey: [],
            });
          }}
        />
      </div>

      <Form noValidate name="userProctoringForm" className="proctoringForm">
        <div className="details-img-seperate">
          <div className="user-profile">
            <span className="userImage" onClick={() => setShowProfile(true)}>
              <img
                width={"135"}
                height={"100"}
                alt="userImage"
                src={profileData?.registerUrl}
              />
            </span>
          </div>

          <Modal
            className="proctoringProfile"
            show={showProfile}
            onHide={() => setShowProfile(false)}
          >
            <img
              width={"100%"}
              height={"300"}
              alt="userImage"
              src={profileData?.registerUrl}
            />
          </Modal>

          <div className="student-details-proctor">
            <h4>{Alert.showBreadCrumbsData.studentName}</h4>
            <div className="proctoringDetailsInnerDiv">
              <span className="userName">
                {/* Tab Switches Icon */}
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5 2.5H9.73333C11.2268 2.5 11.9735 2.5 12.544 2.79065C13.0457 3.04631 13.4537 3.45426 13.7094 3.95603C14 4.52646 14 5.27319 14 6.76667V11.5M4.13333 14.5H9.53333C10.2801 14.5 10.6534 14.5 10.9387 14.3547C11.1895 14.2268 11.3935 14.0229 11.5213 13.772C11.6667 13.4868 11.6667 13.1134 11.6667 12.3667V6.96667C11.6667 6.21993 11.6667 5.84656 11.5213 5.56135C11.3935 5.31046 11.1895 5.10649 10.9387 4.97866C10.6534 4.83333 10.2801 4.83333 9.53333 4.83333H4.13333C3.3866 4.83333 3.01323 4.83333 2.72801 4.97866C2.47713 5.10649 2.27316 5.31046 2.14532 5.56135C2 5.84656 2 6.21993 2 6.96667V12.3667C2 13.1134 2 13.4868 2.14532 13.772C2.27316 14.0229 2.47713 14.2268 2.72801 14.3547C3.01323 14.5 3.3866 14.5 4.13333 14.5Z"
                    stroke="#667085"
                    strokeWidth="1.4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                Tab Switches: {profileData?.switched ?? 0}
              </span>

              <span className="userName">
                {/* Credibility Score Icon */}
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.52181 2.80205C7.67547 2.49076 7.75229 2.33511 7.85659 2.28538C7.94734 2.24211 8.05277 2.24211 8.14351 2.28538C8.24781 2.33511 8.32464 2.49076 8.4783 2.80205L9.93608 5.75536C9.98144 5.84726 10.0041 5.89321 10.0373 5.92889C10.0666 5.96048 10.1018 5.98607 10.1409 6.00425C10.1851 6.02479 10.2358 6.0322 10.3372 6.04702L13.598 6.52364C13.9414 6.57383 14.1131 6.59893 14.1926 6.6828C14.2617 6.75577 14.2942 6.85603 14.281 6.95569C14.2659 7.07022 14.1416 7.19129 13.893 7.43342L11.5343 9.73078C11.4608 9.8024 11.424 9.83821 11.4003 9.88081C11.3793 9.91854 11.3658 9.95998 11.3607 10.0028C11.3548 10.0513 11.3635 10.1018 11.3808 10.203L11.9373 13.4479C11.996 13.7902 12.0254 13.9613 11.9702 14.0628C11.9222 14.1512 11.8369 14.2132 11.7381 14.2315C11.6245 14.2525 11.4708 14.1717 11.1634 14.0101L8.24829 12.4771C8.15746 12.4293 8.11205 12.4054 8.0642 12.396C8.02184 12.3877 7.97827 12.3877 7.9359 12.396C7.88806 12.4054 7.84264 12.4293 7.75181 12.4771L4.83666 14.0101C4.52932 14.1717 4.37565 14.2525 4.26202 14.2315C4.16316 14.2132 4.07786 14.1512 4.02987 14.0628C3.97471 13.9613 4.00406 13.7902 4.06276 13.4479L4.6193 10.203C4.63665 10.1018 4.64532 10.0513 4.63945 10.0028C4.63426 9.95998 4.62078 9.91854 4.59978 9.88081C4.57606 9.83821 4.53929 9.8024 4.46576 9.73078L2.10708 7.43342C1.85848 7.19129 1.73418 7.07022 1.71906 6.95569C1.7059 6.85603 1.73841 6.75577 1.80754 6.6828C1.887 6.59893 2.05869 6.57383 2.40207 6.52364L5.66291 6.04702C5.76432 6.0322 5.81503 6.02479 5.85919 6.00425C5.89828 5.98607 5.93348 5.96048 5.96283 5.92889C5.99598 5.89321 6.01866 5.84726 6.06402 5.75536L7.52181 2.80205Z"
                    stroke="#667085"
                    strokeWidth="1.4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                Credibility Score: {profileData?.credibilityScore ?? 0}
              </span>
              <span className="userName">
                {/* Time Taken Icon */}
                <svg
                  width="20"
                  height="21"
                  viewBox="0 0 20 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.1333 9.5L13.8004 8.16667L12.4666 9.5M14 8.5C14 11.8137 11.3137 14.5 8 14.5C4.68629 14.5 2 11.8137 2 8.5C2 5.18629 4.68629 2.5 8 2.5C10.2013 2.5 12.1257 3.68542 13.1697 5.45273M8 5.16667V8.5L10 9.83333"
                    stroke="#667085"
                    strokeWidth="1.4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                Time Taken:{" "}
                {profileData?.duration !== ""
                  ? profileData?.duration
                  : "No Data"}
              </span>
              {profileData?.location?.address && (
                <span className="userName">
                  {/* Date Icon */}
                  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.66667 5.83333C4.9875 5.83333 5.26215 5.7191 5.49062 5.49062C5.7191 5.26215 5.83333 4.9875 5.83333 4.66667C5.83333 4.34583 5.7191 4.07118 5.49062 3.84271C5.26215 3.61424 4.9875 3.5 4.66667 3.5C4.34583 3.5 4.07118 3.61424 3.84271 3.84271C3.61424 4.07118 3.5 4.34583 3.5 4.66667C3.5 4.9875 3.61424 5.26215 3.84271 5.49062C4.07118 5.7191 4.34583 5.83333 4.66667 5.83333ZM4.66667 10.1208C5.85278 9.03194 6.73264 8.04271 7.30625 7.15312C7.87986 6.26354 8.16667 5.47361 8.16667 4.78333C8.16667 3.72361 7.82882 2.8559 7.15312 2.18021C6.47743 1.50451 5.64861 1.16667 4.66667 1.16667C3.68472 1.16667 2.8559 1.50451 2.18021 2.18021C1.50451 2.8559 1.16667 3.72361 1.16667 4.78333C1.16667 5.47361 1.45347 6.26354 2.02708 7.15312C2.60069 8.04271 3.48056 9.03194 4.66667 10.1208ZM4.66667 11.6667C3.10139 10.3347 1.93229 9.09757 1.15937 7.95521C0.386458 6.81285 0 5.75556 0 4.78333C0 3.325 0.469097 2.16319 1.40729 1.29792C2.34549 0.432639 3.43194 0 4.66667 0C5.90139 0 6.98785 0.432639 7.92604 1.29792C8.86424 2.16319 9.33333 3.325 9.33333 4.78333C9.33333 5.75556 8.94688 6.81285 8.17396 7.95521C7.40104 9.09757 6.23194 10.3347 4.66667 11.6667Z" fill="#667085" />
                  </svg>
                  Location:{" "} <a href={mapUrl} target="_blank" rel="noopener noreferrer">
                    {profileData?.location?.address || "No Data"}
                  </a>
                </span>)}
            </div>
          </div>
        </div>
        <div>
          <div className="libdTabs"></div>

          <TabSwitching
            setActiveTab={setActiveTab}
            activeTab={activeTab}
            eventdata={profileData.eventdata}
            profileData={profileData}
            getProctorData={getProctorData}
            handleSelectImage={handleSelectImage}
            setShowAll={setShowAll}
            handleDeleteImg={handleDeleteImg}
            showAll={showAll}
            deleteImages={deleteImages}
          />
          {/* {activeTab === "images" && <ProctoredDataDetails />} */}
        </div>

        {/* <hr className="proctoringLine" /> */}
      </Form>
    </Offcanvas>
  );
};

export default ProctoredPopup;
